import {Link} from 'react-router-dom';
import {SectionHeader} from '../ui/SectionHeader.jsx';

export function CategoryRail({categories}) {
  return <section className="section shell popular-section"><SectionHeader title="Popular Categories" to="/categories" action="Browse All Categories"/><div className="category-circles">{categories.map(category => <Link key={category.id} to={`/catalog?category=${category.slug}`}><span><img src={category.image} alt="" loading="lazy"/></span><b>{category.name}</b></Link>)}</div></section>;
}
